import getScreenSize, { clientWidth, clientHeight } from './getSreenSize';
import getPageOffset from './getPageOffset';

const screenSize = getScreenSize();
const { offsetTop, offsetLeft } = getPageOffset(screenSize);

export default {
    clientWidth,
    clientHeight,
    screenSize,
    offsetTop,
    offsetLeft,
    dpr: window.devicePixelRatio || 1,
};
